var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViolet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76671 12.7289C4.9158 12.2948 3.87386 12.6329 3.43977 13.4838C3.00564 14.3349 3.34361 15.3766 4.19449 15.8108C5.04552 16.2449 6.08758 15.9068 6.52155 15.0562C6.9558 14.2048 6.61783 13.1628 5.76671 12.7289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71403 11.6779C4.56506 12.1121 5.60687 11.774 6.041 10.9228C6.47512 10.0719 6.13728 9.03 5.28612 8.59587C4.43512 8.16175 3.39331 8.49984 2.95931 9.35075C2.52522 10.2019 2.86303 11.2436 3.71403 11.6779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26673 10.6264C8.41573 10.1923 7.3738 10.5304 6.93967 11.3813C6.5057 12.2325 6.84364 13.2744 7.69464 13.7082C8.54555 14.1423 9.58736 13.8043 10.0216 12.9534C10.4556 12.1025 10.1178 11.0606 9.26673 10.6264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23336 7.54462C4.08423 7.97874 5.12592 7.64093 5.56004 6.78974C5.99429 5.93862 5.65636 4.89693 4.80517 4.46306C3.95417 4.02893 2.91248 4.36649 2.47836 5.21765C2.04414 6.06884 2.38232 7.11053 3.23336 7.54462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78571 6.49362C7.93471 6.05928 6.89289 6.39709 6.45889 7.24821C6.02464 8.0994 6.36258 9.14106 7.21377 9.57515C8.06464 10.0093 9.10633 9.67146 9.54058 8.82031C9.97483 7.96918 9.63674 6.92774 8.78571 6.49362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7667 8.52419C11.9157 8.09007 10.874 8.42788 10.4397 9.27907C10.0057 10.1299 10.3435 11.1716 11.1946 11.606C12.0456 12.0401 13.0874 11.7023 13.5217 10.8509C13.9559 10 13.6177 8.95832 12.7667 8.52419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2857 4.39088C11.4347 3.95703 10.3929 4.29484 9.95876 5.146C9.52476 5.99688 9.86257 7.03881 10.7136 7.47294C11.5646 7.90678 12.6064 7.56897 13.0406 6.71806C13.4747 5.86694 13.1367 4.825 12.2857 4.39088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73306 5.44212C7.58409 5.87621 8.626 5.53815 9.06 4.68753C9.49425 3.83612 9.15619 2.79443 8.30531 2.36031C7.45428 1.92618 6.41231 2.26428 5.97834 3.11515C5.54422 3.96634 5.88219 5.00802 6.73306 5.44212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8561 3.20578L10.8191 3.69688L11.6653 2.03831L12.8103 2.62231L13.3015 1.65931L10.0483 0L9.55713 0.962969L10.7022 1.54697L9.8561 3.20578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolet);
export default __webpack_public_path__ + "static/media/Violet.ed36da4a188cb1936cf9be04deb4fbfb.svg";
export { ForwardRef as ReactComponent };